export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login"),
    meta: { title: "登录" },
    children: [],
  },
  {
    path: "/user",
    name: "user",
    component: () => import("@/views/users/home"),
    meta: { title: "用户中心" },
    redirect: "/user/account",
    children: [
      {
        path: "account",
        name: "account",
        component: () => import("@/views/users/account"),
        meta: { title: "我的账户" },
        children: [],
      },
      {
        path: "resource",
        name: "resource",
        component: () => import("@/views/users/resource"),
        meta: { title: "发布资产" },
        children: [],
      },
      {
        path: "resource/:type/:id",
        name: "resource-id",
        component: () => import("@/views/users/resource"),
        meta: { title: "编辑资产" },
        children: [],
      },
      {
        path: "myAssets",
        name: "myAssets",
        component: () => import("@/views/users/myAssets"),
        meta: { title: "我的资产" },
        children: [],
      },

      {
        path: "myDownload",
        name: "myDownload",
        component: () => import("@/views/users/myDownload"),
        meta: { title: "已购资产" },
        children: [],
      },
      {
        path: "integral",
        name: "integral",
        component: () => import("@/views/users/integral"),
        meta: { title: "我的余额" },
        children: [],
      },
      {
        path: "notice",
        name: "notice",
        component: () => import("@/views/users/notice"),
        meta: { title: "消息通知" },
        children: [],
      },
      {
        path: "active",
        name: "active",
        component: () => import("@/views/users/active"),
        meta: { title: "热门活动" },
        children: [],
      },
      {
        path: "workorder",
        name: "workorder",
        component: () => import("@/views/users/workorder"),
        meta: { title: "我的工单" },
        children: [],
      },
	    {
        path: "withdrawal",
        name: "withdrawal",
        component: () => import("@/views/users/withdrawal"),
        meta: { title: "搜点提现" },
        children: [],
	    },
      {
        path: "tx",
        name: "tx",
        component: () => import("@/views/users/tx"),
        meta: { title: "红包提现" },
        children: [],
      },
    ],
  },
];
